import React from 'react';
import RSC from 'react-scrollbars-custom';
import './FieldEditorCustomScrollbars.css';

// https://codesandbox.io/s/bvaughnreact-window-react-scrollbars-custom-pjyxs

const CustomScrollbars = ({
  forwardedRef,
  children,
  onScroll,
  style,
  className,
}: {
  forwardedRef: any;
  children?: any;
  onScroll?: any;
  style?: any;
  className?: any;
}) => {
  // Note: Custom styling in FieldEditorCustomScrollbars.css !!
  return (
    <div data-ce-custom-scroll="true" data-testid="ce-field-editor-option-list">
      <RSC
        className={className}
        style={style}
        scrollerProps={{
          renderer: (props) => {
            const elementRef = props.elementRef;
            const rscOnScroll = props.onScroll;
            const { ...restProps } = props;
            delete restProps.elementRef;
            delete restProps.onScroll;

            return (
              <span
                {...restProps}
                onScroll={(e) => {
                  onScroll(e);
                  if (rscOnScroll) {
                    //  const ec = e as UIEvent<HTMLDivElement>;
                    rscOnScroll(e as any);
                  }
                }}
                ref={(ref) => {
                  forwardedRef(ref);
                  if (elementRef) {
                    elementRef(ref as any);
                  }
                }}
              />
            );
          },
        }}
      >
        {children}
      </RSC>
    </div>
  );
};

export const CustomScrollbarsForVirtualList = React.forwardRef((props, ref) => <CustomScrollbars {...props} forwardedRef={ref} />);
